export enum ModuleState {
  Idle,
  HotelsPending,
  OffersPending,
  SearchCompleted,
  MoreHotelsPending
}

export enum AnchorType {
  hotel,
  place
}

export const URL_PARAMS_TO_IGNORE_FOR_SEARCHES = [
  'layout',
  'redirectId',
  'closeSearchBox',
  'offerFilters',
  'roomFilters',
  'roomUserSearch',
  'srpSearchId',
  'scrollAnchorId',
  'anonymousId',
  'openHotelDetails',
  'clickedOffer',
  'clickedBundle',
  'clickedBase',
  'clickedTaxes',
  'clickedFees',
  'clickedProvider',
  'redirectId',
  'clickedUserIp',
  'enablePriceWatch',
  'componentPriceWatch',
  'priceWatchId',
  'overlay',
  'scrollToRooms',
  'scrollToRoom',
  'showAllOffers'
] as const

export enum OfferAccessFlow {
  PrivateLockedDeal = 'privateLockedDeal',
  AppLocked = 'appLocked',
  RegularDeal = 'regularDeal'
}

export type BaseOfferAccessFlowSettings = {
  // if the offer is locked
  isLocked: boolean
  // which type of auth flow does offer require
  flowType?: OfferAccessFlow
}

/**
 * Variations of conditions needed for offer access flow - all are derived from isLocked and flowType
 *
 * In order to know which one suits your use case read the instructions below:
 *
 * If condition is post-fixed with "Locked" it means:
 *  - offer is locked on SRP and did not satisfy META unlocking conditions
 *  - offer will also be locked on AP
 * If condition is post-fixed with "RequiredUnlocked" it means:
 *  - offer is NOT locked on SRP and satisfied META unlocking conditions
 *  - SRP will only annotate the offer with the requirement on AP but allows navigation
 *  - offer will still be locked on AP
 * If condition is post-fixed with "Required" it means:
 *  - offer will require an extra step to be booked either on SRP or AP
 *  - It is either "Locked" or "RequiredUnlocked" - the union of the previous two
 *
 * Variations where an offer does not reqiure any access flow are composed applying logical not (!) to the above conditions
 */
export type OfferAccessFlowSettings = {
  // type of auth flow offer requires - relevant for both SRP and AP
  flowType: OfferAccessFlow
  // if the offer is locked - relevant only for SRP
  isLocked: boolean
  // if offer requires either of access flows (app or auth)
  isSpecial: boolean
  // if offer is special but is unlocked on SRP, due to META unlocking conditions
  isSpecialUnlocked: boolean
  // if access flow requires auth, either on SRP or AP
  isAuthRequired: boolean
  // if access flow requires app, either on SRP or AP
  isAppRequired: boolean
  // if access flow is locked on SRP by auth
  isAuthLocked: boolean
  // if access flow is locked on SRP by app
  isAppLocked: boolean
  // if access flow requires auth but is unlocked on SRP, due to META unlocking conditions
  isAuthRequiredUnlocked: boolean
  // if access flow requires app but is unlocked on SRP, due to META unlocking conditions
  isAppRequiredUnlocked: boolean
}
